import _ from 'underscore';
import { Partner } from './partner';

//TODO: combine this with PartnerEditController, lots of duped code.
export default function PartnerNewController(
  PartnerService,
  SitesService,
  AdTypesFactory,
  FlashService,
  $window,
  PartnerUtilitiesService
) {
  const vm = this;
  vm.errors = [];
  vm.isNewPartner = true;
  vm.defaultSites = [];
  vm.RTB_VERSIONS = ['2.2', '2.3'];
  vm.handleTypeChange = handleTypeChange;
  vm.siteSelected = siteSelected;
  vm.save = save;
  vm.setLogo = setLogo;

  initialize();

  return vm;

  function initialize() {
    // TODO: clean this up so a partner is initialized in one palces in new and edit controllers
    vm.partner = new Partner();

    vm.colorOptions = {
      format: 'rgb',
      alpha: false
    };

    SitesService.defaultSites().then(sites => {
      vm.defaultSites = sites;
    });

    vm.adTypes = AdTypesFactory.ALL_TYPES;
    vm.toggleSites = PartnerUtilitiesService.toggleSelection;
  }

  function handleTypeChange() {
    if (vm.partner.partnerType === 'DSP') {
      vm.partner.rtbVersion = vm.partner.rtbVersion || vm.RTB_VERSIONS[0];
    } else {
      vm.partner.rtbVersion = null;
    }
  }

  function siteSelected({ id }) {
    return !!_.findWhere(vm.partner.sites, { id: id });
  }

  function save() {
    const outcome = PartnerUtilitiesService.validatePartnerOutcome(vm.partner);

    if (outcome.successful) {
      return PartnerService.create(vm.partner).then(
        () => {
          $window.location = '/partners';
        },
        ({ data }) => {
          vm.errors = data.errors;
          return FlashService.push('error', 'Something went wrong.');
        }
      );
    } else {
      FlashService.push('error', outcome.errors.join(', '));
    }
  }

  function setLogo(file) {
    vm.partner.logo = file;
  }
}

PartnerNewController.$inject = [
  'PartnerService',
  'SitesService',
  'AdTypesFactory',
  'FlashService',
  '$window',
  'PartnerUtilitiesService'
];
